import api from './api';

export interface HistoricoMedicao {
  id: string;
  medicaoId: string;
  usuarioResponsavel?: string;
  statusAnterior?: string;
  novoStatus?: string;
  descricao?: string;
  dataHoraFormatada: string;
}

export interface HistoricoRateio {
  id: string;
  medicaoId: string;
  usuarioResponsavel?: string;
  statusAnterior?: string;
  novoStatus?: string;
  descricao?: string;
  dataHoraFormatada: string;
}

export interface HistoricoSla {
  id: string;
  medicaoId: string;
  usuarioResponsavel?: string;
  statusAnterior?: string;
  novoStatus?: string;
  descricao?: string;
  dataHoraFormatada: string;
}

export const getAllHistoricoMedicaoById = (id: string) => api.get<HistoricoMedicao[]>(`historicoMedicao/${id}`);

export const getAllHistoricoMedicaoLogNdaById = (id: string) =>
  api.get<HistoricoMedicao[]>(`historicoMedicao/getAllHistoricoMedicaoLogNda/${id}`);

export const getAllHistoricoRateioById = (id: string) => api.get<HistoricoRateio[]>(`historicoRateio/${id}`);

export const getAllHistoricoSlaById = (id: string) => api.get<HistoricoSla[]>(`historicoMedicao/GetHistoricoSla/${id}`);
